module.exports = __webpack_public_path__ + "static/media/Nota Gelatinas.97b1045b.png";